// Dev server environment — values injected at build time via webpack DefinePlugin
// (see system-env-config.js). CI/CD sets the matching process.env.* variables.
export const environment = {
  production: false,
  showDebugInformation: true,
  API_URL: $ENV.API_URL,
  ISSUER_URL: $ENV.ISSUER_URL,
  CLIENT_ID: $ENV.CLIENT_ID,
  REDIRECT_URI: $ENV.REDIRECT_URI,
  POST_LOGOUT_REDIRECT_URL: $ENV.POST_LOGOUT_REDIRECT_URL,
  AG_GRID_LICENSE_KEY: $ENV.AG_GRID_LICENSE_KEY,
  SUPPORT_CENTER_URL: $ENV.SUPPORT_CENTER_URL,
};
